import Axios from 'axios';
import { axiosApi } from './api';
import store from "../store/index"

// 报警统计
export const GetAccidentStatistics = (params) => axiosApi('get', '/alarm/event/num/project')(params);

// 报警环比
const _getAccidentByDay = axiosApi('get', '/alarm/num/day');
const _getAccidentByWeek = axiosApi('get', '/alarm/num/week');
const _getAccidentByMonth = axiosApi('get', '/alarm/num/month');
export const GetAccidentCompareDay = (projectId) => Axios.all([
    _getAccidentByDay({d: 0, projectId: projectId}),
    _getAccidentByDay({d: 1, projectId: projectId})
]);
export const GetAccidentCompareWeek = (projectId) => Axios.all([
    _getAccidentByWeek({w: 0, projectId: projectId}),
    _getAccidentByWeek({w: 1, projectId: projectId})
]);
export const GetAccidentCompareMonth = (projectId) => Axios.all([
    _getAccidentByMonth({m: 0, projectId: projectId}),
    _getAccidentByMonth({m: 1, projectId: projectId})
]);

// 报警排名
export const GetAccidentRank = (params) => axiosApi('get', '/alarm/event/num/ranking')(params);
export const GetAccidentRankDetail = (params) => axiosApi('get', '/alarm/event/num/area')(params);

// 最新报警
export const GetAccidentTimeline = (params) => axiosApi('get', '/alarm/details/type')(params);
export const GetAccidentDetailForId = (id) => axiosApi('get', '/alarm/details')({alarmId: id});

// 按类别分页查询时间段内的报警
export const GetDetailList = (params) => axiosApi('get', '/alarm/details/condition')(params);

// 获取报警时的快照数据
export const GetAccidentValue = (id) => axiosApi('get', '/diagram/snapshot')({alarmId: id});

//标记事件为已读
export const SetAccidentRead = (accidentIds) => axiosApi('put', '/alarm/check', true)(accidentIds);

//全部标记为已读
export const SetAllRead = (id) => axiosApi('get', '/alarm/all/read')({projectId: id});

//标记事件为已确认
export const SetAccidentCheck = (accidentIds) => axiosApi('put', '/alarm/checkalarm', true)(accidentIds);

//事件统计
export const AlarmStatistics = (params) => axiosApi('get', '/alarm/event/statistics', true)(params);
